export default function isValidUrl(url: string): boolean {
  /* eslint-disable no-useless-escape */
  const urlRegex = /^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/;
  return urlRegex.test(url);
}
